import { NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { GlobalRegistryService } from '../../../core/global-registry/global-registry.service';
import { NoteModel } from '../../../core/models/notes/note.model';
import { SensorModel } from '../../../core/models/sensor/sensor.model';
import { WidgetModel } from '../../../core/models/widget/widget.model';
import { AttributeService } from '../../../core/services/api/attribute/attribute.service';
import { CacheResolverService } from '../../../core/services/api/cache/cache-resolver.service';
import { CompanyService } from '../../../core/services/api/company/company.service';
import {
    DeviceModel,
    ObjectModel,
    ObjectService,
} from '../../../core/services/api/objects/object.service';
import { SensorService } from '../../../core/services/api/sensor/sensor.service';
import { TypesService } from '../../../core/services/api/types/types.service';
import { UnitTypeModel } from '../../../core/services/api/unit-type/unit-type.service';
import { DataService } from '../../../core/services/websocket/data.service';
import { FapModalComponent } from '../../partials';
import { NavService } from '../../services/nav.service';
import { AgmGeocoder, MapsAPILoader } from '@agm/core';
import { MapService } from '../../layout/fap_main-map/service/map-service';
import { UtcToLocalPipe } from '../../../core/pipes/utcToLocal.pipe';
import { UserService } from '../../../core/services/api/user/user.service';

export const DATE_TIME_FORMAT = {
    parse: {
      dateInput: 'l, LTS',
    },
    display: {
      dateInput: 'YYYY-MM-DD',
      monthYearLabel: 'MM yyyy',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    }
}

interface marker {
    lat: number;
    lng: number;
    label?: string;
    draggable: boolean;
    content: string;
    color?: string;
    iconUrl?: string;
  }
  
  interface coords {
    lat: number;
    lng: number;
  }

@Component({
    selector: 'fap-overview-widget',
    templateUrl: './fap-overview-widget.component.html',
    styleUrls: ['./fap-overview-widget.component.scss'],
    providers: [{provide: NGX_MAT_DATE_FORMATS, useValue: DATE_TIME_FORMAT}]
})
export class FapOverviewWidgetComponent
    implements OnInit, OnDestroy, OnChanges
{
    @Input()
    public widget: WidgetModel;
    @Input() objects: ObjectModel[] = [];
    @Input() sensors: SensorModel[] = [];
    @Input() unitTypes: UnitTypeModel[] = [];

    public selectedWidget;

    @Input()
    public notes: NoteModel[];

    @Output()
    public emitShow: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('addEditWidgetModal') addEditWidgetModal: FapModalComponent;
    @ViewChild('sensorInformationPopup')
    sensorInformationPopup: FapModalComponent;
    @ViewChild('automationPopup') automationPopup: FapModalComponent;
    @ViewChild('schedulerPopup') schedulerPopup: FapModalComponent;
    @ViewChild('schedulerTriggerModal') schedulerTriggerModal: FapModalComponent;
    public lotName: string;

    public toggleMain = false;
    public toggleSub = false;
    public personList: any;
    public showMenu = true;
    public fromDate = new Date();
    public toDate = new Date();
    public agg = 'day';
    public dataSource: any[] = [];
    public finalSensorList = [];
    public sensorNames = [];
    public columns: any[] = [];
    public sensorIds = [];
    public units: [];
    public currentSensors: [];
    public subscriptions: Array<Subscription> = [];
    public mediaUrl = environment.mediaUrl;
    public translatedNames: any = [];
    @Input() public langString: string;
    @Input()
    public devices: Array<DeviceModel> = [];
    @ViewChild('addEditTranslationsPopup')
    public addEditTranslationsPopup: FapModalComponent;
    @ViewChild('addEditAutomationTranslationPopup')
    public addEditAutomationTranslationPopup: FapModalComponent;
    
    public automationFormData = null;
    public formType = null;
    public fields = null;
    public formFields = null;
    public autoFormFields = null;
    public currentSensor;
    public addEditSensorInformationForm: UntypedFormGroup;
    public addEditAutomationForm: UntypedFormGroup;
    
    public sensorInformation = null;
    public automations = [];
    public schedulers = [];
    public automation = null;
    public scheduler = null;
    @ViewChild('nameInput', { static: true }) nameInput: ElementRef;
    @ViewChild('nameInput1', { static: true }) nameInput1: ElementRef;
    @ViewChild('nameInput2', { static: true }) nameInput2: ElementRef;
    public translation = null;
    public automationTranslation = null;
    public chips = [];
    
    public automationForm = [];
    public sensorInformationForm = [];
    public sensorData = null;
    
    apiCalled = false;
    @ViewChild('mapModal')
    public mapModal: FapModalComponent;
    public isLoading = false;
    zoom = 8;
    markers:Array<marker> = [];
    public searchControl: UntypedFormControl;
    public mapSearchToggle: boolean;
    public mapTypeControl: boolean;
    @ViewChild('search', {static: true}) public searchElementRef: ElementRef;
    @Output()
    public coords: EventEmitter<coords> = new EventEmitter();
    defaultCenter = {lat: 51.673858, lng: 7.815982};
    currentCenter = Object.assign({}, this.defaultCenter);
    private utcToLocalPipe: UtcToLocalPipe;
    private timezone;
    public label: string = null;
    public localSensorData: any = [];

    constructor(
        private globalRegistry: GlobalRegistryService,
        public companyService: CompanyService,
        public navService: NavService,
        public sensorService: SensorService,
        public toastr: ToastrService,
        public translateService: TranslateService,
        public dataService: DataService,
        public objectService: ObjectService,
        public cacheService: CacheResolverService,
        public typesService: TypesService,
        public attributeService: AttributeService,
        public formBuilder: UntypedFormBuilder,
        public mapService: MapService,
        private mapsAPILoader: MapsAPILoader, private ngZone: NgZone,
        private geocoder: AgmGeocoder,
        private userService: UserService
    ) {
        // this.utcToLocalPipe = new UtcToLocalPipe();
        this.subscriptions.push(this.userService.getCurrentUser.subscribe((user) => {
            this.timezone = user.profile.data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
            // console.log(this.timezone);
        }));
    }

    public toggleImageMenu() {
        this.showMenu = !this.showMenu;
    }

    ngOnInit(): void {
        this.fromDate = new Date();
        this.toDate = new Date();
        this.agg = '';

        setTimeout(() => {
            this.drillData();
        }, 2000);

        this.subscriptions.push(
            this.sensorService.getName.subscribe((res) => {
                if (res) {
                    this.dataSource = [];
                    this.drillData();
                }
            })
        );
        this.translatedNames = this.globalRegistry.systemData.translations;
        this.initAddEditSensorInformationForm();
        this.initAddEditAutomationForm();
        // this.initAddEditSchedulerForm();

        this.searchControl = new UntypedFormControl();

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.currentCenter.lat = place.geometry.location.lat();
          this.currentCenter.lng = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
    }

    showModal(widget): void {
        this.selectedWidget = widget;
        this.addEditWidgetModal.showModal();
    }

    public getLotName(lotId: number = this.widget.objectId) {
        if(lotId != 0) {
            const lot = this.globalRegistry.systemData.lots.find((lot) => lot.id === lotId);
            return lot ? lot.name : '';
        }
    }

    hideMain() {
        this.toggleMain = false;
    }

    toggleMenu() {
        this.toggleMain = !this.toggleMain;
    }

    getLocalSensors(sensorIds: number[]) {
        const objects = Object.values(this.objects);
        const unitTypes = Object.values(this.unitTypes);
        const sensors = Object.values(this.sensors);
        const devices = Object.values(this.devices);
        
        return sensorIds.map(sensorId => {
            const sensor = sensors.find(s => s.id === sensorId);
            if (!sensor) return null;
    
            return {
                unitTypes: unitTypes.filter(el => el.id === sensor.unitType),
                objects: objects.filter(el => el.id === sensor.objectId),
                currentSensor: sensor,
                devices: devices.filter(el => el.id === sensor.device),
            };
        }).filter(Boolean);
    }    

    public async drillData() {
        this.isLoading = true;
        this.dataSource = [];
        const sensorIds = this.widget["settings"]["sensors"].map(
            (sensor) => sensor?.id
          );
        try {
            const data = await this.dataService.getLastData(sensorIds).toPromise();
            this.localSensorData = this.getLocalSensors(sensorIds);
            this.sensorNames = await Promise.all(this.localSensorData.map(async (item) => {
                const nameT = item.currentSensor.nameT ? await this.getTranslation(item.currentSensor.nameT) : '';
                const extraText = item.objects[0].nameT ? await this.getTranslation(item.objects[0].nameT) : item.objects[0].extraText || '';
                const unit = item.unitTypes[0].nameT ? await this.getTranslation(item.unitTypes[0].nameT) : item.unitTypes[0].name;
                return nameT ? nameT : extraText + ' ' + unit;
            }));
            this.currentSensors = this.localSensorData.map((item) => item.currentSensor);
            this.units = this.localSensorData.map((item) => item.unitTypes[0].unit);
    
            this.dataSource = this.localSensorData.map((localSensor, i) => {
                const dataItem = data.find((dataItem) => dataItem.sensor === localSensor.currentSensor.id) || {};
                const name = this.sensorNames[i];
                const unit = this.units[i];
                const date = dataItem.timestamp ? moment.utc(dataItem.timestamp).local().fromNow() : null;
    
                return {
                    ...localSensor,
                    ...dataItem,
                    name,
                    unit,
                    date,
                    currentSensor: this.currentSensors[i]
                };
            });
    
            this.isLoading = false;
        } catch (error) {
            console.error('Error fetching data:', error);
            this.isLoading = false;
        }
    }
      

    ngOnChanges(changes: SimpleChanges) {
        if (Object.prototype.hasOwnProperty.call(changes, 'widget') && this.widget) {
            this.getLotName(this.widget.objectId);
        }
    }

    public getform(id) {
        this.automationForm = [];
        const url = this.attributeService.getUrl('form/');
        this.cacheService.delete(url);
        this.attributeService.getForm(id).subscribe(data => {
        //   console.log(data);
          this.automationFormData = data.body.results;
          const formTypeFields = this.automationFormData.fields
                const itemIds = formTypeFields.map((item) => item.type);
                this.autoFormFields = this.globalRegistry.systemData.attributes.filter((item) =>
                    itemIds.includes(item.id)
            );
            formTypeFields.forEach(field => {
            this.autoFormFields.forEach(attr => {
                if(field.type === attr.id) {
                    // console.log(attr);
                    // console.log(field);
                    this.automationForm.push(field);
                    this.addEditAutomationForm.addControl(field.id, new UntypedFormControl(field.value.input, Validators.required))
                    // console.log(this.addEditAutomationForm.value);
                }
            })
        })
        })
      }

    public getFormTypes(item) {
        this.schedulerTriggerModal.showModal();
        this.sensorData = item;
    }

    toggleValue(val) {
        console.log(val);
    }

    convertKeysToCamelCase(obj) {
        const camelCaseObj = {};
        for (const key in obj) {
            const camelCaseKey = key.replace(/_([a-z])/g, (m, p1) =>
                p1.toUpperCase()
            );
            camelCaseObj[camelCaseKey] =
                obj[key] instanceof Object
                    ? this.convertKeysToCamelCase(obj[key])
                    : obj[key];
        }
        return camelCaseObj;
    }

    onAddUpdateTranslation(translation) {
        console.log(translation);
        this.translation = translation;
        this.addEditSensorInformationForm.controls['name_t'].setValue(
            translation.id
        );
        this.addEditSensorInformationForm.controls['name'].setValue(
            translation[this.langString]
        );
        this.translation = translation;
        this.addEditTranslationsPopup.hideModal();
    }

    onAddUpdateAutomationTranslation(translation) {
        console.log(translation);
        this.automationTranslation = translation;
        this.addEditAutomationForm.controls['name_t'].setValue(
            translation.id
        );
        this.addEditAutomationForm.controls['name'].setValue(
            translation[this.langString]
        );
        this.automationTranslation = translation;
        this.addEditAutomationTranslationPopup.hideModal();
    }

    

    submitForm() {
        console.log(this.addEditSensorInformationForm.value);
        const excludedTriggerIds = this.automations.filter(automation => !this.addEditSensorInformationForm.value.automation.includes(automation.id))
            .map(automation => automation.id);
            this.automations = this.automations.filter(automation => !this.addEditSensorInformationForm.value.automation.includes(automation.id));
        const { ...clonedObj } = this.addEditSensorInformationForm.value;
        // console.log(clonedObj);
        // console.log(this.sensorInformationForm);
        for (const key in clonedObj) {
            this.sensorInformationForm.forEach(item => {
                if(String(item.id) === key) {
                    // console.log(item);
                    item.value.input = clonedObj[key]
                    this.attributeService.patchField(item.id, item).subscribe(data => {
                        console.log(data);
                        this.sensorInformationPopup.hideModal();
                    })
                }
            });
          }
        const body = {
            name_t: this.translation ? this.translation.id : '',
        }
        this.sensorService.updateSensorName(this.currentSensor.id, body).subscribe(data => {
            // console.log(data);
            this.currentSensor = data.model
        })

        excludedTriggerIds.forEach(id => {
            this.sensorService.deleteTrigger(id).subscribe();
        });
    }

    editAutomation(automation) {
        // console.log(automation);
        this.automation = automation;
        this.automationPopup.showModal();
        this.initAddEditAutomationForm();
        this.getform(automation.form);
    }0
    editScheduler(scheduler) {
        // console.log(scheduler);
        this.scheduler = scheduler;
        // this.days = this.scheduler.day;
        this.scheduler.hour = this.scheduler.hour ? typeof this.scheduler.hour === 'string' ? this.scheduler.hour.split(',') : this.scheduler.hour : ''
        this.schedulerPopup.showModal();
        // this.initAddEditSchedulerForm();
    }

    deleteAutomation(id) {
        this.sensorService.deleteTrigger(id).subscribe(()=> {
            this.automationPopup.hideModal();
            this.getAutomation();
        }, (error) => {
            this.toastr.error(error.error.results.error);
        });
    }

    deleteScheduler(id) {
        this.sensorService.deleteScheduler(id).subscribe(() => {
            this.schedulerPopup.hideModal();
            this.getSchedulers();
        }, (error) => {
            this.toastr.error(error.error.results.error)
        })
    }

    submitAutomation() {
        console.log(this.addEditAutomationForm.value);
        const { ...clonedObj } = this.addEditAutomationForm.value;
        // console.log(clonedObj);
        // console.log(this.automationForm);
        for (const key in clonedObj) {
            this.automationForm.forEach(item => {
                if(String(item.id) === key) {
                    // console.log(item);
                    item.value.input = clonedObj[key]
                    this.attributeService.patchField(item.id, item).subscribe(() => {
                        // console.log(data);
                        this.automationPopup.hideModal();
                    })
                }
            });
          }
        const body = {
            name_t: this.automationTranslation ? this.automationTranslation.id : '',
            scheduler: this.addEditAutomationForm.value.scheduler
        }
        // console.log(this.automation);
        if(this.automation) {
            this.sensorService.updateTrigger(this.automation.id, body).subscribe(() => {
                // console.log(data);
                this.getAutomation();
            })
        }
    }

    getTranslation(translation) {
        const t = this.globalRegistry.systemData.translations.filter((trans) => {
            return trans.id === translation;
        });
        if(t[0]) {
            if(t[0][this.langString] === null || t[0][this.langString] === '') {
              return translation
            } else {
              return t[0][this.langString];
            }
          } else {
            return translation;
        }
    }

    initAddEditSensorInformationForm() {
        // console.log(this.currentSensor);
        
        this.addEditSensorInformationForm = this.formBuilder.group({
            name: [
                this.currentSensor ? this.currentSensor.name : '',
                Validators.required,
            ],
            name_t: [
                this.currentSensor ? this.currentSensor.nameT : '',
                Validators.required,
            ],
            device: [
                this.currentSensor ? this.currentSensor.device : '',
                Validators.required,
            ],
            automation: [null],
        });
        if(this.currentSensor && this.currentSensor.nameT) {
            this.globalRegistry.systemData.translations.forEach(
                (translation) => {
                    if (translation.id === this.currentSensor.nameT) {
                        this.translation = translation;
                    }
                }
            );
            this.addEditSensorInformationForm.get('name').setValue(this.getTranslation(this.currentSensor.nameT))
        }
    }

    removeItem(id) {
        this.chips = this.chips.filter(item => item !== id);
        this.addEditSensorInformationForm.get('automation').setValue(this.chips)
      }

    filterAutomation(keyword) {
        console.log(keyword)
    }

    getAutomation() {
        const param = {sensor: this.currentSensor.id}
        const url = this.sensorService.getUrl('trigger/');
        this.cacheService.delete(url+'sensor='+this.currentSensor.id)
        if (this.currentSensor) {
            this.sensorService
                .getTriggers(param)
                .subscribe((data) => {
                    console.log(data);
                    this.getSchedulers()
                    this.automations = data.body.results;
                    const itemIds = this.automations.map((item) => item.id)
                    this.addEditSensorInformationForm.get('automation').setValue(itemIds)
                    this.chips = itemIds;
                });
        }
    }

    validateAutomationPopup() {
        // console.log(this.currentSensor);
        this.sensorService.postTrigger({sensor: this.currentSensor.id}).subscribe(() => {
            // console.log(data);
            this.getAutomation();
        })
    }

    getSchedulers() {
        const url = this.sensorService.getUrl('scheduler/');
        this.cacheService.delete(url);
        if (this.currentSensor) {
            this.sensorService
                .getSchedulers()
                .subscribe((data) => {
                    // console.log(data);
                    this.schedulers = data.body.results;
                });
        }
    }

    updatechips(value) {
        this.chips = value;
    }

    initAddEditAutomationForm() {
        this.addEditAutomationForm = this.formBuilder.group({
            name: [
                this.automation ? this.automation.name : '',
                Validators.required,
            ],
            name_t: [
                this.automation ? this.automation.name_t : '',
                Validators.required,
            ],
            scheduler: [
                this.automation ? this.automation.scheduler : '',
                Validators.required,
            ]
        });
        if(this.automation && this.automation.name_t) {
            this.globalRegistry.systemData.translations.forEach(
                (translation) => {
                    if (translation.id === this.automation.name_t) {
                        this.automationTranslation = translation;
                    }
                }
            );
            this.addEditAutomationForm.get('name').setValue(this.getTranslation(this.automation.name_t))
        }
    }

    addEditTranslation(label: string, inputElement: any, translationTarget: any, popup: any, form: any) {
        this.label = label;
        const name = this[inputElement].nativeElement.value;
        const type: any = this.convertKeysToCamelCase(translationTarget);
    
        if (name === null || name === '' || type.nameT === null) {
            this.translation = null;
            popup.showModal();
        } else {
            for (const translation of this.globalRegistry.systemData.translations) {
                if (type && translation.id === type.nameT) {
                    this.translation = translation;
                    console.log(this.translation);
                    popup.showModal();
                    return;
                }
            }
    
            if (Object.keys(type).length === 0 && name) {
                const newTranslation = this[form].controls['name_t'].value;
                for (const translation of this.globalRegistry.systemData.translations) {
                    if (translation.id === newTranslation) {
                        this.translation = translation;
                        console.log(this.translation);
                        popup.showModal();
                        return;
                    }
                }
            }
        }
    }
    
    // public initGraphConfigModalButtons(): void {
    //     const _this: FapOverviewWidgetComponent = this;
      
    //     this.graphConfigModalButtonPrimaryInterface = {
    //         clickFunction(): void {
    //             _this.submitGraphConfig();
    //         },
    //         text: this.translateService.instant('save')
    //     };
      
    //     this.graphConfigModalButtonSecondaryInterface = {
    //         clickFunction(): void {
    //             _this.graphConfigModal.hideModal();
    //         },
    //         text: this.translateService.instant('cancel')
    //     };
    // }
    
    displayCoord(info) {
        this.mapModal.showModal();
        // console.log(info);
        const lng = info.coordinates[0];
        const lat = info.coordinates[1];
        this.markers = [];
        this.markers.push({
          lat: lat,
          lng: lng,
          draggable: false,
          content: lat +', '+ lng,
          iconUrl: this.setMarkerIconColor('red')
        });
        this.coords.emit({lat, lng});
        this.currentCenter.lat = lat;
        this.currentCenter.lng = lng;
    }

    public setMarkerIconColor(markerColor: string): string {
        return (
            'http://maps.google.com/mapfiles/ms/icons/' +
            markerColor +
            '-dot.png'
        );
    }

    mapClicked($event) {
        console.log($event)
      }

      mapReady(event) {
        console.log(event);
        this.setCurrentPosition();
      }

      private setCurrentPosition() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.currentCenter.lat = position.coords.latitude;
            this.currentCenter.lng = position.coords.longitude;
            this.zoom = 15;
          });
        }
      }
    
      markerDragEnd(m: marker, $event) {
        console.log("dragEnd", m, $event);
      }

      getTitleContent(input: string) {
        return input.replace(/<[^>]*>/g, ' ');
      }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => {
            s.unsubscribe();
        });
    }
}
